import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactCountryFlag from "react-country-flag";

const LANGS = [
  { code: "en", label: "English", region: "EN", flag: "GB" },
  { code: "ar", label: "العربية", region: "SA", flag: "SA" },
];

function getInitialLang() {
  const doc = document.documentElement;
  const fromDoc = (doc && doc.lang) || "";
  if (fromDoc.toLowerCase().startsWith("ar")) return "ar";

  try {
    const saved = localStorage.getItem("aicooking_lang");
    if (saved === "ar" || saved === "en") return saved;
  } catch (e) {}

  return "en";
}

export function LanguageDropdown() {
  const [open, setOpen] = useState(false);
  const [lang, setLang] = useState(getInitialLang);
  const popRef = useRef(null);
  const btnRef = useRef(null);

  const current = useMemo(() => LANGS.find((l) => l.code === lang) || LANGS[0], [lang]);

  useEffect(() => {
    // Ensure the static landing content is in sync.
    if (typeof window.setSouschAifLanguage === "function") {
      window.setSouschAifLanguage(lang);
    }
  }, [lang]);

  useEffect(() => {
    function onDocClick(e) {
      if (!open) return;
      const pop = popRef.current;
      const btn = btnRef.current;
      if (pop && pop.contains(e.target)) return;
      if (btn && btn.contains(e.target)) return;
      setOpen(false);
    }
    function onKeyDown(e) {
      if (!open) return;
      if (e.key === "Escape") {
        setOpen(false);
        btnRef.current?.focus?.();
      }
    }
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  function pick(next) {
    setLang(next);
    setOpen(false);
    try {
      localStorage.setItem("aicooking_lang", next);
    } catch (e) {}
  }

  return (
    <div className="lang-menu" aria-label="Language">
      <button
        ref={btnRef}
        type="button"
        className="lang-menu-btn"
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <ReactCountryFlag countryCode={current.flag} svg style={{ width: "1.15em", height: "1.15em" }} />
        <span style={{ flex: "1 1 auto", textAlign: "start" }}>{current.label}</span>
        <span className="lang-muted">{current.region}</span>
      </button>

      {open ? (
        <div ref={popRef} className="lang-pop" role="listbox" aria-label="Select language">
          {LANGS.map((l) => (
            <button
              key={l.code}
              type="button"
              role="option"
              aria-selected={l.code === lang}
              className="lang-item"
              onClick={() => pick(l.code)}
            >
              <span className="lang-left">
                <ReactCountryFlag countryCode={l.flag} svg style={{ width: "1.15em", height: "1.15em" }} />
                <span>{l.label}</span>
              </span>
              <span className="lang-muted">{l.region}</span>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}


